import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import type { RootState } from "../../store/types.tsx";
import SelectLLMModel from "./SelectLLMModel.tsx";
import GoogleSheetDrawerAction from "./GoogleSheetDrawerAction.tsx";
import MemoryDrawerAction from "./MemoryDrawerAction.tsx";
import NotificationsDrawerAction from "../notifications/NotificationsDrawerAction.tsx";
import { useFeatureFlag } from "../../hooks/useFeatureFlag.tsx";

interface ConversationDrawerActionsProps {
  closeDrawer: () => void;
}

const ConversationDrawerActions: React.FC<ConversationDrawerActionsProps> = ({
  closeDrawer,
}) => {
  const availableModels = useSelector(
    (state: RootState) => state.conversationState.availableModels,
  );

  const isGoogleSheetsEnabled = useFeatureFlag("google_sheets");

  return (
    <Box
      marginBottom={2}
      sx={{
        py: "4px",
        backgroundColor: "inherit",
        flexShrink: 0,
      }}
    >
      <NotificationsDrawerAction closeDrawer={closeDrawer} />

      <MemoryDrawerAction closeDrawer={closeDrawer} />

      {isGoogleSheetsEnabled && (
        <GoogleSheetDrawerAction closeDrawer={closeDrawer} />
      )}

      {availableModels && availableModels.length > 0 && (
        <SelectLLMModel availableModels={availableModels} />
      )}
    </Box>
  );
};

export default ConversationDrawerActions;
